import { inject, Service } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@services/toast';

@Service()
export class MessageService {
  private readonly toastService = inject(ToastService);
  private readonly translate = inject(TranslateService);

  showSuccessMessage(text: string): void {
    void this.toastService.showSuccessAsync(text);
  }

  showErrorMessage(text: string): void {
    void this.toastService.showErrorAsync(`${this.translate.instant('general.error')}: ${text}`);
  }
}
